import axios from 'axios';

export default {
  getBanner(params = {}) {
    return axios.get(`/user/banner`);
  },
};
